// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Xn4sL","header":"PatientBlock_header__1GNeW","label":"PatientBlock_label__2uWJT","option":"PatientBlock_option__AZsKv"};